import React from 'react';

export default function ChartCard({ title, subtitle, children, height = 260 }) {
  return (
    <div className="p-6 rounded-xl bg-paper-2 border border-shell-border shadow-soft">
      <h3 className="text-sm font-semibold text-ink">{title}</h3>
      {subtitle ? <p className="text-xs text-mute mb-5">{subtitle}</p> : null}
      {children}
    </div>
  );
}

export function ChartContainer({ height = 260, children }) {
  return <div style={{ width: '100%', height }}>{children}</div>;
}
